const mock = {
  value: 'This is mock text',
};

export default mock;
